import Cookies from '@/services/cookies'
import config from './config'
import * as types from './mutation_types'
import { forEach, sumBy, take, findLast, uniq, map } from 'lodash'

// этот метод возвращает объект вариации по имени теста, беря его из куки или инициализируя
function getTestVariation (rootState, testConfig) {
  let variationKey = Cookies.get(testConfig.name)

  const keys = map(testConfig.variations, 'key')
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  const setParams = params['set_' + testConfig.name]
  if (setParams) {
    variationKey = setParams
    Cookies.set(testConfig.name, variationKey, { expires: testConfig.cookieExpirationDays })
  }

  if (variationKey && keys.includes(variationKey)) {
    const variation = findLast(testConfig.variations, (variation) => {
      return variation.key === variationKey
    })
    return variation
  } else {
    Cookies.remove(testConfig.name)
    const variation = runTest(testConfig)
    Cookies.set(testConfig.name, variation.key, { expires: testConfig.cookieExpirationDays })
    return variation
  }
}

// этот метод просто запускает рандом и возвращает объект вариации
function runTest (testConfig) {
  const probabilitySum = sumBy(testConfig.variations, 'probability')
  if (probabilitySum !== 1) {
    throw new Error('У теста ' + testConfig.name + ' задано некорректное распределение вероятностей')
  } else {
    const keys = map(testConfig.variations, 'key')
    if (uniq(keys).length !== keys.length) {
      throw new Error('У теста ' + testConfig.name + ' существуют одинаковые ключи')
    } else {
      const randomNumber = Math.random()
      const tresholdsList = testConfig.variations.map((variation, index) => {
        return {
          variationIndex: index,
          value: sumBy(take(testConfig.variations, index), 'probability'),
        }
      })

      const selectedVariationIndex = findLast(tresholdsList, (treshold) => {
        return randomNumber > treshold.value
      }).variationIndex

      return testConfig.variations[selectedVariationIndex]
    }
  }
}

export default {
  initializeTests: ({ rootState, rootGetters, dispatch, commit }) => new Promise((resolve) => {
    const domainResult = {}
    const runTestIndexes = []
    const dontRunTestIndexes = []
    const testsVariations = {}
    forEach(config.tests, (testConfig, i) => {
      if (testConfig.needRunTest({ rootState, rootGetters })) {
        runTestIndexes.push(i)
      } else {
        dontRunTestIndexes.push(i)
      }
    })
    forEach(dontRunTestIndexes, (i) => {
      const testConfig = config.tests[i]
      const changes = testConfig.variations.find(variation => {
        return variation.key === config.emptyTestKey
      }).execute()
      forEach(changes, (value, key) => {
        domainResult[key] = value
      })
      dispatch('analytics/sendAbTestVariation', { testName: testConfig.name, variationKey: null, dimensionIndex: testConfig.gaDimensionIndex }, { root: true })
    })
    forEach(runTestIndexes, (i) => {
      const testConfig = config.tests[i]
      const variation = getTestVariation(rootState, testConfig)
      testsVariations[testConfig.name] = variation.key
      const changes = variation.execute()
      forEach(changes, (value, key) => {
        domainResult[key] = value
      })
      dispatch('analytics/sendAbTestVariation', { testName: testConfig.name, variationKey: variation.key, dimensionIndex: testConfig.gaDimensionIndex }, { root: true })
    })
    commit(types.SET_TESTS_VARIATIONS_FULLY, testsVariations)
    commit(types.UPDATE_VARIATIONS_DOMAIN_FULLY, JSON.parse(JSON.stringify(domainResult)))
    dispatch('analytics/trackActiveTestsWithVariations', testsVariations, { root: true })
    resolve()
  }),
  processSiteDepartmentChange: ({ dispatch }) => new Promise((resolve, reject) => {
    dispatch('abtesting/initializeTests', true, { root: true }).then(() => {
      resolve()
    }, (error) => {
      reject(error)
    })
  }),

  initializeYandexABFlags ({ dispatch, commit, state, rootGetters }) {
    const MAX_INIT_COUNT = 5

    if (!state.yandexABFlagsInitCount) {
      commit('SET_YANDEX_AB_INIT_COUNT', 1)
    }

    if (!window.ymab && state.yandexABFlagsInitCount <= MAX_INIT_COUNT) {
      commit('SET_YANDEX_AB_INIT_COUNT', 1 + state.yandexABFlagsInitCount)
      setTimeout(function () {
        dispatch('initializeYandexABFlags')
      }, 1500)
      return
    }

    window.yamb && window.ymab('metrika.33171113', 'getFlags', (flags) => {
      if (!flags) {
        return
      }
      commit('SET_AB_FLAGS', flags)
      dispatch('gtm/initializeYandexABFlagsEvent', flags)
    })
  },
}
